import i18n from '@/i18n'
import { h, ref, resolveDirective, withDirectives } from 'vue'

export const moduleRefreshCallback = ref<Function>()

export function getStatus(isActive: boolean, isApplicable: boolean) {
	let status = ''

	if (isActive && isApplicable) {
		status = 'applicable'
	} else if (isActive && !isApplicable) {
		status = 'inapplicable'
	} else {
		status = 'excluded'
	}

	return status
}

export function getStatusIndicator(status: string) {
	const tooltip = resolveDirective('tooltip')

	return withDirectives(
		h('i', {
			title: i18n.global.t(`module.status.${status}`),
			class: ['bi', 'bi-circle-fill', status],
		}),

		[[tooltip!, i18n.global.t(`module.status.${status}`)]],
	)
}
